import styled from 'styled-components';

import ActionButton from 'components/ActionButton';

export const StyledButton = styled(ActionButton)`
  margin: 20px 0;
  text-transform: none;
`;
